import CustButton from "../CustButton";

const Welcoming = ({ data }) => {

  const { title, content } = data;

  return (
    <div
      className=""
      style={{
        backgroundImage:
          "url('https://res.cloudinary.com/dr0lbokc5/image/upload/v1702146276/Group_37877_glv3ug.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="vh-100 d-flex justify-content-center cust-welcoming">
        <div className="w-75 px-5">
          <h1 className="title-welcoming">{title}</h1>
          <p className="text-body-tertiary fs-4">{content}</p>
          <div className="w-auto">
            {content ? (
              <CustButton text="Consult with us" path="/" />
            ) : (
              <CustButton text="Waiting for Data Hero" path="/" />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Welcoming;
